import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { LoginGuard } from './guard/login.guard';
import { ViewComponent, LoginViewComponent } from '@xanadu/component';

const routes: Routes = [
    // {
    //     path: '',
    //     component: ViewComponent,
    //     canActivate: [AuthGuard]
    //     // data: { roles: ['admin'] }
    // },
    {
        path: 'login',
        component: LoginViewComponent,
        canActivate: [LoginGuard],
    },

    // otherwise redirect to home
    {
        path: '**',
        component: ViewComponent,
        canActivate: [AuthGuard]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
